import * as EventBusAny from "eventbusjs";
var EventBus = EventBusAny;
export { EventBus };